
<div class="custom-index-view">
  <index-panel
    :collection="`users/${user.uid}/customIndexes`"
    :doc="$route.params.name"
  />
</div>
